import React from "react";
import img from "./p2p.png";

const Concept = () => {
  return (
    <div>
      <img
        src={img}
        style={{ width: "100%", maxWidth: "600px" }}
        alt="peer-communication"
      />
      <p className="step-p">
        <p>0. Start with the genesis block. </p>
        <p>1. Add <b>TWO</b> blocks. </p>
        <p>2. Add a peer & connect. </p>
        <p>3. Check history between peer. </p>
      </p>
      <p className="step-p">
        The longer valid chain takes precedent over a shorter chain. Also called <b>longest chain rule</b>.
      </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/communicate-3/concept.js